export enum AuthenticationMode {
	header = 'header',
	cookie = 'cookie',
}